<template>
	<li class="search-tag">
		<a class='tag-body' @click.prevent.stop="selected"><span class="search-type">{{tag.type}} :</span> {{tag.content}}</a><a  @click.prevent.stop="remove" class="remove"></a>
	</li>
</template>

<script>
	export default {

		props: ['tag'],

		methods: {

			selected() {
				UWEvent.fire('tagSelected', this.tag)
			},

			remove() {
				UWEvent.fire('tagRemoved', this.tag)
			},

		}

	}
</script>


<style>

	.search-tag {
		background-color: #cde69c;
		border-radius: 2px;
		border: 1px solid #a5d24a;
		color: #638421;
		display: inline-block;
		font-size: 13px;
		font-weight: 400;
		margin-bottom: 4px;
		margin-right: 4px;
		padding: 3px;
	}

	.search-tag .search-type {
		font-weight: bold;
		font-style: italic;
	}


	.search-tag .remove {
		cursor: pointer;
		font-weight: bold;
		background-color: #eeeeee;
		color: #ff9999;
		margin-left:2px;
		padding-right:2px;
		border-radius: 2px;
	}
	.search-tag a {
		color: inherit;
		cursor: pointer;
	}

	.search-tag .tag-body:hover {
		text-decoration: none;
	}

	.search-tag .remove:hover {
		text-decoration: none;
	}

	.search-tag .remove::before {
		content: " x";
	}
	
	.new-tag {
		background: transparent;
		border: 0;
		color: #777;
		font-size: 13px;
		font-weight: 400;
		margin-bottom: 6px;
		margin-top: 1px;
		outline: none;
		padding: 4px;
		padding-left: 0;
		width: 80px;
	}
	.search-tag-wrapper.read-only {
		cursor: default;
	}
</style>